module.exports = __webpack_public_path__ + "static/media/NHL_Western_Conference.8a9f009c.svg";